import type { TimelineBoardKey } from '../types/schema'

export type TimelineBoardCode = 'v' | 'd' | 'a' | 'b'

export const BOARD_CODE_BY_KEY: Record<TimelineBoardKey, TimelineBoardCode> = {
  VISIONBOARD: 'v',
  DASHBOARD: 'd',
  ARCHIVE: 'a',
  BIN: 'b',
}

export const BOARD_KEY_BY_CODE: Record<TimelineBoardCode, TimelineBoardKey> = {
  v: 'VISIONBOARD',
  d: 'DASHBOARD',
  a: 'ARCHIVE',
  b: 'BIN',
}

export const BOARD_ROUTE_LABEL_BY_KEY: Record<TimelineBoardKey, string> = {
  VISIONBOARD: 'v',
  DASHBOARD: 'd',
  ARCHIVE: 'a',
  BIN: 'b',
}

export const parseBoardCode = (code: string | undefined): TimelineBoardKey | null => {
  if (!code) return null
  return BOARD_KEY_BY_CODE[code as TimelineBoardCode] ?? null
}

export const segmentForOrdinal = (prefix: 'g' | 't' | 's' | 'c', ordinal: number) =>
  `${prefix}${Math.max(1, Math.floor(ordinal))}`

export const buildDisplayId = (workspaceSlug: string, board: TimelineBoardKey, routePath: string) => {
  const path = routePath.trim().toLowerCase().replace(/^\/+|\/+$/g, '').replaceAll('/', '-')
  return [workspaceSlug, BOARD_CODE_BY_KEY[board], path].filter(Boolean).join('-')
}

export const normalizeRoutePath = (value: unknown) =>
  typeof value === 'string'
    ? value.trim().toLowerCase().replace(/^\/+|\/+$/g, '')
    : ''

export const placementSignature = (
  workspaceId: string,
  board: TimelineBoardKey,
  parentRoutePath: string,
  type: 'GOAL' | 'TASK' | 'SUBTASK' | 'CHECKLIST',
) => [
  workspaceId,
  BOARD_CODE_BY_KEY[board],
  // parentRoutePath contains '/' for depth ≥ 2 (e.g. "g15/t1"); this value
  // ends up inside Firestore doc ids, and Firestore rejects any doc id
  // containing '/' as an invalid reference (odd-segment count). Flatten
  // with '-' — same separator buildDisplayId uses when rendering paths.
  (normalizeRoutePath(parentRoutePath) || 'root').replaceAll('/', '-'),
  type.toLowerCase(),
].join('__')
